interface EmojiProps {
  ariaLabel: string;
  emojiSymbol: string;
  fontSize?: string;
}

function Emoji({ ariaLabel, emojiSymbol, fontSize }: Readonly<EmojiProps>): JSX.Element {
  return (
    <span className="emoji" role="img" aria-label={ariaLabel} css={{ fontSize }}>
      {emojiSymbol}
    </span>
  );
}

export default Emoji;
